import {useState} from 'react';

function useButtonThrottle(): [boolean, (time: number) => void] {
    const [isButtonThrottled, setIsButtonThrottled] = useState(false);

    const startThrottling = (time: number): void => {
        setIsButtonThrottled(true);
        setTimeout(() => {
            setIsButtonThrottled(false);
        }, time);
    };

    return [isButtonThrottled, startThrottling];
}

export default useButtonThrottle;
